"use strict";
// See: https://github.com/react/react/issues/11538#issuecomment-417504600
function patchNode() {
    if (typeof Node === "function" && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function (child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error("Cannot remove a child from a different parent", child, this);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function (node, child) {
            if (child && child.parentNode !== this) {
                if (console) {
                    console.error("Cannot insert before a reference node from a different parent", child, this);
                }
                return node;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
if (navigator?.userAgent?.includes?.("Chrome")) {
    patchNode();
}
